import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { money } from "../../lib/format";

const cell = "px-4 py-3 text-right whitespace-nowrap";

export const StatementTable = ({ st, year, years, onYear }) => (
  <section className="mt-10 bg-white rounded-[2rem] border border-black/5 overflow-hidden" data-testid="statement-section">
    <div className="p-6 flex flex-wrap items-center justify-between gap-4 border-b border-black/5">
      <div>
        <p className="eyebrow text-[#E07A5F]">Hesap Ekstresi</p>
        <h2 className="font-display text-xl font-bold text-slate-800 mt-1">Aylık aidat ve ödemeler</h2>
      </div>
      <div className="flex items-center gap-2 text-sm">
        <span className="text-slate-500">Başlangıç yılı</span>
        <Select value={String(year)} onValueChange={(v) => onYear(Number(v))}>
          <SelectTrigger className="w-28 rounded-full" data-testid="statement-year-select"><SelectValue /></SelectTrigger>
          <SelectContent>
            {years.map((y) => <SelectItem key={y} value={String(y)} data-testid={`statement-year-${y}`}>{y}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
    </div>
    <div className="overflow-x-auto">
      <table className="w-full text-sm" data-testid="statement-table">
        <thead className="bg-[#FDFBF7] text-slate-500">
          <tr>
            <th className="px-4 py-3 text-left font-semibold">Ay</th>
            <th className="px-4 py-3 text-right font-semibold">Aidat</th>
            <th className="px-4 py-3 text-right font-semibold">Ek Borç</th>
            <th className="px-4 py-3 text-right font-semibold">Ödeme</th>
            <th className="px-4 py-3 text-right font-semibold">Bakiye</th>
          </tr>
        </thead>
        <tbody>
          {!st && <tr><td colSpan={5} className="p-6 text-center text-slate-400">Yükleniyor...</td></tr>}
          {st?.rows.map((r, i) => (
            <tr key={i} className="border-t border-black/5 hover:bg-[#D8F3DC]/30 transition-colors" data-testid={`statement-row-${i}`}>
              <td className="px-4 py-3 font-semibold text-slate-700 whitespace-nowrap">
                {r.ay} {r.yil}
                {r.extra_charges?.map((c, j) => <span key={j} className="block text-xs font-normal text-slate-400">{c.description}</span>)}
              </td>
              <td className={cell}>{r.aidat_amount ? money(r.aidat_amount) : "—"}</td>
              <td className={cell}>{r.extra_amount ? money(r.extra_amount) : "—"}</td>
              <td className={`${cell} text-[#2D6A4F] font-semibold`}>{r.payment_amount ? money(r.payment_amount) : "—"}</td>
              <td className={`${cell} font-bold ${r.balance > 0 ? "text-[#B4492F]" : "text-[#1B4332]"}`}>{money(r.balance)}</td>
            </tr>
          ))}
        </tbody>
        {st && (
          <tfoot className="bg-[#1B4332] text-white font-bold">
            <tr>
              <td className="px-4 py-3">Toplam</td>
              <td className={cell}>{money(st.totals.aidat)}</td>
              <td className={cell}>{money(st.totals.extra)}</td>
              <td className={cell}>{money(st.totals.payment)}</td>
              <td className={cell} data-testid="statement-total-balance">{money(st.totals.balance)}</td>
            </tr>
          </tfoot>
        )}
      </table>
    </div>
  </section>
);
